import React from 'react'
import {CustomIconButton} from "../buttons/buttonsActions";

const ViewSelectedHours = props => {
    const {selectedHours, onRemoveHour} = props

    return <div className={'selected-hours-container'}>
        {
            selectedHours.map((value,i) => <div key={`item-${i}`} className={'selected-hour-container'}>
                    <div className={'selected-hour'}> {value} </div>
                    <CustomIconButton icon='fa fa-minus-circle' clazz='btn-hour-selected' onClick={()=> onRemoveHour(i)}/>
                </div>
            )
        }
    </div>
}

export default ViewSelectedHours